(() => {
  if (window.CrochetStudioMakerReviews) { window.CrochetStudioMakerReviews.init(document); return; }
  const mounted = new Map();
  const mount = root => {
    if (mounted.has(root)) return;
    const track = root.querySelector('[data-csr-track]');
    const cards = [...root.querySelectorAll('[data-csr-card]')];
    const play = root.querySelector('[data-csr-play]'), label = root.querySelector('[data-csr-play-label]');
    const ring = root.querySelector('[data-csr-timer]'), status = root.querySelector('[data-csr-status]');
    if (!track || !cards.length || !play || !ring) return;
    const motion = matchMedia('(prefers-reduced-motion: reduce)'), hover = matchMedia('(hover:hover)');
    const cleanups = [], animations = new Set();
    let frame = 0, cycle = null, playing = false, inView = false, revealed = false;
    const on = (node, name, fn, options) => { node.addEventListener(name, fn, options); cleanups.push(() => node.removeEventListener(name, fn, options)); };
    const animate = (node, frames, options) => {
      if (motion.matches || typeof node?.animate !== 'function') return;
      const animation = node.animate(frames, options);
      animations.add(animation);
      animation.finished.catch(() => {}).finally(() => animations.delete(animation));
      return animation;
    };
    const step = () => cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : cards[0].offsetWidth;
    const maxScroll = () => Math.max(0, track.scrollWidth - track.clientWidth);
    const index = () => Math.max(0, Math.round(track.scrollLeft / step()));
    const stopCycle = () => { const old = cycle; cycle = null; old?.cancel(); };
    const timerCanRun = () => playing && inView && !document.hidden && !motion.matches
      && !(hover.matches && root.matches(':hover'))
      && !(root.contains(document.activeElement) && document.activeElement !== play);
    const syncTimer = () => {
      if (!timerCanRun()) { cycle?.pause(); return; }
      if (cycle) { cycle.play(); return; }
      if (typeof ring.animate !== 'function') return;
      const current = ring.animate([{strokeDashoffset:1},{strokeDashoffset:0}], {duration:6500,easing:'linear',fill:'forwards'});
      cycle = current;
      current.finished.then(() => {
        if (cycle !== current || !playing) return;
        cycle = null; current.cancel();
        if (track.scrollLeft >= maxScroll() - 2) track.scrollTo({left:0,behavior:'instant'});
        else go(index() + 1, false);
        syncTimer();
      }).catch(() => {});
    };
    const setPlaying = value => {
      playing = value && cards.length > 1 && !motion.matches && typeof ring.animate === 'function';
      play.setAttribute('aria-pressed',String(playing));
      label.textContent = playing ? play.dataset.pauseLabel : play.dataset.playLabel;
      root.toggleAttribute('data-csr-playing',playing);
      if (!playing) stopCycle(); else syncTimer();
    };
    const update = () => {
      frame = 0;
      const active = index();
      cards.forEach((card,i) => card.toggleAttribute('data-csr-current',i === active));
    };
    const go = (target,manual = true) => {
      if (manual) setPlaying(false);
      const destination = Math.min(cards.length - 1,Math.max(0,target));
      track.scrollTo({left:Math.min(maxScroll(),destination * step()),behavior:motion.matches ? 'auto' : 'smooth'});
      const photo = cards[destination]?.querySelector('.csr-card__photo img');
      if (photo) animate(photo,[{transform:'scale(1.055)'},{transform:'scale(1)'}],{duration:900,easing:'cubic-bezier(.2,.7,.2,1)'});
      if (manual) status.textContent = (destination + 1) + ' / ' + cards.length;
    };
    root.setAttribute('data-csr-ready','');
    on(play,'click',() => setPlaying(!playing));
    on(track,'scroll',() => { if (!frame) frame = requestAnimationFrame(update); },{passive:true});
    on(track,'pointerdown',() => setPlaying(false),{passive:true});
    on(track,'keydown',event => {
      if (event.target !== track) return;
      const targets = {ArrowLeft:index() - 1,ArrowRight:index() + 1,Home:0,End:cards.length - 1};
      if (!(event.key in targets)) return;
      event.preventDefault(); go(targets[event.key]);
    });
    const measureQuotes = () => {
      cards.forEach(card => {
        const quote = card.querySelector('[data-csr-quote]'), button = card.querySelector('[data-csr-more]');
        if (!card.hasAttribute('data-csr-expanded')) button.hidden = quote.scrollHeight <= quote.clientHeight + 1;
      });
      update();
    };
    cards.forEach(card => {
      const button = card.querySelector('[data-csr-more]');
      on(button,'click',() => {
        setPlaying(false);
        const expanded = !card.hasAttribute('data-csr-expanded');
        card.toggleAttribute('data-csr-expanded',expanded);
        button.setAttribute('aria-expanded',String(expanded));
        button.textContent = expanded ? button.dataset.closeLabel : button.dataset.openLabel;
      });
    });
    const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
      inView = entries[0].isIntersecting;
      if (inView && !revealed && !motion.matches) {
        revealed = true;
        cards.slice(0,3).forEach((card,i) => animate(card,[{opacity:.4,transform:'translateY(18px)'},{opacity:1,transform:'translateY(0)'}],{duration:620,delay:i * 95,easing:'cubic-bezier(.2,.7,.2,1)'}));
      }
      syncTimer();
    },{threshold:.1}) : null;
    observer?.observe(root);
    if (!observer) inView = true;
    const resize = 'ResizeObserver' in window ? new ResizeObserver(measureQuotes) : null;
    resize?.observe(track);
    on(window,'resize',measureQuotes);
    on(document,'visibilitychange',syncTimer);
    on(root,'mouseenter',syncTimer); on(root,'mouseleave',syncTimer);
    on(root,'focusin',syncTimer); on(root,'focusout',() => requestAnimationFrame(syncTimer));
    on(motion,'change',() => {
      play.hidden = cards.length < 2 || motion.matches || typeof ring.animate !== 'function';
      if (motion.matches) { setPlaying(false); animations.forEach(a => a.cancel()); }
    });
    play.hidden = cards.length < 2 || motion.matches || typeof ring.animate !== 'function';
    measureQuotes();
    setPlaying(true);
    document.fonts?.ready.then(() => { if (root.isConnected) measureQuotes(); });
    mounted.set(root,() => {
      playing = false; stopCycle(); cancelAnimationFrame(frame); observer?.disconnect(); resize?.disconnect();
      animations.forEach(a => a.cancel()); cleanups.forEach(fn => fn());
    });
  };
  const init = scope => scope.querySelectorAll?.('[data-csr]').forEach(mount);
  document.addEventListener('shopify:section:load',event => init(event.target));
  document.addEventListener('shopify:section:unload',event => {
    for (const [root,cleanup] of mounted) if (event.target.contains(root)) { cleanup(); mounted.delete(root); }
  });
  window.CrochetStudioMakerReviews = {init};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',() => init(document),{once:true});
  else init(document);
})();
